export default __webpack_public_path__ + "static/media/R_Rato.3adfd552.mp3";